<template lang="pug">
  div
    section.content-header
      h1 モバイルログイン設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active モバイルログイン設定

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link.btn.btn-default(:to="{name: 'admin'}" title="キャンセル") キャンセル

        +btnbar
        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-body
            .form-group
              label.control-label 企業コード
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="mbCompanyCodeSave" :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可しない
                label.radio-inline
                  input(type="radio" v-model="mbCompanyCodeSave" :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可する
              .help-block
                p.bcard-comments.text-info
                  | ※ モバイルアプリに企業コードを保存する機能を有効にします。
            hr

            .form-group
              label.control-label ログインID
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="mbloginIdSave" :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可しない
                label.radio-inline
                  input(type="radio" v-model="mbloginIdSave" :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可する
              .help-block
                p.bcard-comments.text-info
                  | ※ モバイルアプリにログインIDを保存する機能を有効にします。
            hr

            .form-group
              label.control-label パスワード
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="mbloginPwdSave" :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可しない
                label.radio-inline
                  input(type="radio" v-model="mbloginPwdSave" :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;保存を許可する
              .help-block
                p.bcard-comments.text-info
                  | ※ モバイルアプリにパスワードを保存する機能を有効にします。
              hr

            .form-group
              label.control-label セッション情報の有効期間
              .form-inline.bcard-moblielogin-session
                .form-group
                  input.form-control(type="number" v-model="mbloginSidTermHour" min="0" max="999")
                  label 時間
                |
                |
                .form-group
                  input.form-control(type="number" v-model="mbloginSidTermMinite" min="-1" max="60")
                  label 分
              .help-block
                p.bcard-comments.text-info
                  | ※ モバイルアプリがログイン状態を維持する期間を、 1 分 ～ 999 時間 59 分 の間で設定します。
                  br
                  | ログアウトした場合は設定値に関係なくセッション情報は破棄されます。

        +btnbar(class="-bottom")
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const MbLoginSettingRepository = RepositoryFactory.get('mbloginsettings')

export default {
  name: 'MbLoginSetting',
  components: { AppMessages, Loading },
  data: function () {
    return {
      mbCompanyCodeSave: '',
      mbloginIdSave: '',
      mbloginPwdSave: '',
      mbloginSidTerm: 60,

      isLoading: true // 読み込み中かどうか
    }
  },
  computed: {
    // セッション情報の有効期間の時の部分を表示する
    mbloginSidTermHour: {
      get: function () {
        return parseInt(this.mbloginSidTerm / 60, 10)
      },
      set: function (newHour) {
        this.mbloginSidTerm = Number(newHour) * 60 + this.mbloginSidTermMinite
        this.resetTermWithinRange()
      }
    },
    // セッション情報の有効期間の分の部分を表示する
    mbloginSidTermMinite: {
      get: function () {
        return parseInt(this.mbloginSidTerm % 60, 10)
      },
      set: function (newMin) {
        this.mbloginSidTerm = Number(newMin) + this.mbloginSidTermHour * 60
        this.resetTermWithinRange()
      }
    }
  },
  created: function () {
    const vm = this

    // 初期値を固定値から設定する
    this.mbCompanyCodeSave = this.app_flag.OFF
    this.mbloginIdSave = this.app_flag.OFF
    this.mbloginPwdSave = this.app_flag.OFF

    // API実行
    MbLoginSettingRepository.get()
      .then(function (response) {
        const res = vm.getApiData(response).data
        vm.mbCompanyCodeSave = res.mbcompanycodesave
        vm.mbloginIdSave = res.mbloginidsave
        vm.mbloginPwdSave = res.mbloginpwdsave
        vm.mbloginSidTerm = res.mbloginsidterm

        vm.isLoading = false
      })
      .catch(function (error) {
        // エラーメッセージを出す
        vm.setErrorMessage(error)
      })
  },
  // モバイルログイン共通メソッド
  methods: {
    // 送信処理
    postData: function () {
      const vm = this
      let params = {
        mbcompanycodesave: vm.mbCompanyCodeSave,
        mbloginidsave: vm.mbloginIdSave,
        mbloginpwdsave: vm.mbloginPwdSave,
        mbloginsidterm: vm.mbloginSidTerm
      }
      // API実行
      MbLoginSettingRepository.put(params)
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    },
    // mbloginSidTermの上限と下限を超えた時の処理を行う
    resetTermWithinRange: function () {
      const valueMin = 1
      const valueMax = 999 * 60 + 59

      // 下限を下回ったら下限にする
      if (this.mbloginSidTerm < valueMin) {
        this.mbloginSidTerm = valueMin
      }
      // 上限を上回ったら上限にする
      if (this.mbloginSidTerm > valueMax) {
        this.mbloginSidTerm = valueMax
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-inline.bcard-moblielogin-session {
    .form-control {
      width: 5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/MbLoginSetting.vue